import { useEffect } from 'react';

const CUSTOM_DOMAIN = 'guardpaths.com';

export const DomainRedirect = () => {
  useEffect(() => {
    // Only run in production
    if (import.meta.env.MODE !== 'production') {
      return;
    }

    // Check if current hostname contains lovable.app
    if (window.location.hostname.includes('.lovable.app')) {
      // Preserve the full path and query parameters
      const newUrl = `https://${CUSTOM_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`;
      
      // Redirect using replace to prevent back button
      window.location.replace(newUrl);
    }
  }, []);

  return null;
};
